import DateFnsUtils from '@date-io/date-fns';
import {
  Button,
  createStyles,
  FormControl,
  FormControlLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from '@material-ui/pickers';
import { PautaEvento } from 'api/Assessor/pautas';
import { ErrorApi } from 'api/interfaces';
import {
  default as sicrediColor,
  default as sicrediStyles,
} from 'assets/styles/default.scss';
import { AxiosError } from 'axios';
import { SyncIcon } from 'components/Icons';
import InputTime, {
  IInputTimeObject,
} from 'components/__ASSESSOR__/InputTime/InputTime';
import { IPauta } from 'components/__SHARED__/AssembleiaPautas/AssembleiaPautasNews';
import { format } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { AssembleiaPautaStatus } from 'helpers/enums/AssembleiaPautaStatus';
import {
  addSomeDaysToDate,
  createDateFromTextValue,
  getHoursAndDate,
} from 'helpers/utils/DateUtils';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import { Collapse } from 'plataforma-fundacao-componentes';
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  assembleiasAssessorActionsAlterarSituacaoPauta,
  assembleiasAssessorActionsAlterarSituacaoPautaPorDataETempo,
} from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';

export interface IAbrirVotacaoPautaModalGenericProps
  extends IGenericModalProps {
  key?: string;
  pauta?: IPauta | PautaEvento;
  idPauta?: number;
  emLote?: boolean;
  notShowSendType?: boolean;
  idEvento?: number;
  pautas?: Number[];
  onSend?: any;
  close?: any;
}

export interface IAbrirVotacaoPautaModal extends IModalProps {
  genericProps?: IAbrirVotacaoPautaModalGenericProps;
}

const useStyles = makeStyles(() =>
  createStyles({
    tempoInput: {
      marginTop: '10px',
      width: '100% !important',
    },
    dropdownIcon: {
      fontSize: 16,
      color: sicrediStyles.primarySicredi,
    },
    actionsContent: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    inputTime: {
      maxWidth: '200px',
    },
    subtitleLiberarEmLote: {
      fontFamily: '"Exo 2", sans-serif!important',
      fontSize: '18px',
      fontWeight: 700,
      color: sicrediColor.secondarySicrediDarker,
    },
    timeContainer: {
      display: 'flex',
      flexDirection: 'column',

      '& span': {
        color: '#f44336',
        fontSize: '12px',
        marginTop: '4px',
      },
    },
  })
);

const INITIAL_STATUS = '00:05:00';

export default function AbrirVotacaoPautaModal({
  genericProps,
  open,
}: IAbrirVotacaoPautaModal) {
  const classes = useStyles();
  const [tempo, setTempo] = useState<IInputTimeObject>();
  const [salvando, setSalvando] = useState<boolean>(false);
  const [valueRadio, setValueRadio] = useState<string>('durationByTime');
  const dispatchAction = useDispatch();
  const currentEvent = useSelector(
    (state: IReducer) => state.assembleiasAssessor.evento
  );

  let dateFinish =
    currentEvent!?.modo === AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL
      ? currentEvent!?.dataFimEventoOnline
      : currentEvent!?.dataFimEvento;
  let datePublished =
    currentEvent!?.modo === AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL
      ? currentEvent!?.dataEventoOnline
      : currentEvent!?.dataEvento;
  const dateFormated = useMemo(() => new Date(dateFinish), [dateFinish]);
  const dateFormatedPublished = useMemo(
    () => new Date(datePublished),
    [datePublished]
  );
  const timeFormat = dateFinish
    ?.substring(dateFinish.indexOf('T') + 1)
    .substring(0, 5);

  const [date, setDate] = useState<any>(format(dateFormated, 'yyyy-MM-dd'));
  const [time, setTime] = useState<any>(timeFormat);

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
    if (genericProps && genericProps.close) {
      genericProps.close();
    }
  }, [dispatchAction, genericProps]);

  const showError = (error: AxiosError<ErrorApi>) => {
    setSalvando(false);
    ErrorHandler(error.response!.data);
  };

  const getSeconds = useCallback((): number => {
    return tempo ? tempo.timeInSeconds : 0;
  }, [tempo]);

  const confirmar = () => {
    setSalvando(true);
    dispatchAction(
      !genericProps!.emLote
        ? assembleiasAssessorActionsAlterarSituacaoPauta(
            genericProps!?.idEvento!,
            genericProps!?.idPauta!,
            valueRadio === 'durationByPeriod' ? `${date}T${time}` : null,
            valueRadio === 'durationByTime' ? getSeconds() : null,
            AssembleiaPautaStatus.Liberada,
            toClose,
            showError
          )
        : assembleiasAssessorActionsAlterarSituacaoPautaPorDataETempo(
            valueRadio === 'durationByPeriod' ? `${date}T${time}` : null,
            valueRadio === 'durationByTime' ? getSeconds() : null,
            genericProps!?.idEvento!,
            genericProps!.pautas,
            toClose,
            genericProps?.onSend,
            showError
          )
    );
  };

  const today = new Date();
  const hour = dateFormated.getHours();
  const minutes =
    dateFormated.getMinutes() <= 9
      ? `0${dateFormated.getMinutes()}`
      : dateFormated.getMinutes();
  const hourPublished = dateFormatedPublished.getHours();
  const minutesPublished = dateFormatedPublished.getMinutes();
  const fullHour = `${hour < 10 ? '0' + hour : hour}:${minutes}`;
  const fullHourPublished = `${
    hourPublished < 10 ? '0' + hourPublished : hourPublished
  }:${minutesPublished < 10 ? '0' + minutesPublished : minutesPublished}`;
  const atualTime = `${
    today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
  }:${today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()}`;

  const confirmarDisabled = useCallback((): boolean => {
    const tempoEmSegundos: number = getSeconds();

    if (
      valueRadio === 'durationByTime' &&
      typeof tempoEmSegundos === 'number' &&
      tempoEmSegundos === 0
    ) {
      return true;
    }

    if (
      (valueRadio === 'durationByPeriod' &&
        date < format(new Date(), 'yyyy-MM-dd')) ||
      (valueRadio === 'durationByPeriod' &&
        date === format(dateFormatedPublished, 'yyyy-MM-dd') &&
        time < fullHourPublished) ||
      (valueRadio === 'durationByPeriod' &&
        date > format(dateFormated, 'yyyy-MM-dd')) ||
      (valueRadio === 'durationByPeriod' &&
        date === format(dateFormated, 'yyyy-MM-dd') &&
        time > fullHour) ||
      (valueRadio === 'durationByPeriod' &&
        date === format(new Date(), 'yyyy-MM-dd') &&
        time < atualTime)
    ) {
      return true;
    }

    return false;
  }, [
    atualTime,
    date,
    dateFormated,
    dateFormatedPublished,
    fullHour,
    fullHourPublished,
    getSeconds,
    time,
    valueRadio,
  ]);

  const durationType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueRadio((event.target as HTMLInputElement).value);
  };

  return (
    <GenericModal
      open={open ?? false}
      title={translation.AbrirVotacaoPautaModal.title}
      content={
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography
              component='h1'
              className={classes.subtitleLiberarEmLote}
            >
              {translation.AbrirVotacaoPautaModal.subTitle}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby='demo-row-radio-buttons-group-label'
                name='row-radio-buttons-group'
                value={valueRadio}
                onChange={(e) => {
                  durationType(e);
                }}
              >
                <FormControlLabel
                  value='durationByTime'
                  control={<Radio />}
                  label={translation.AbrirVotacaoPautaModal.radioGroup.tempo}
                />
                <FormControlLabel
                  value='durationByPeriod'
                  control={<Radio />}
                  label={translation.AbrirVotacaoPautaModal.radioGroup.periodo}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Collapse opened={valueRadio === 'durationByTime'}>
              <InputTime
                className={classes.inputTime}
                value={tempo ? tempo!.timeStr : INITIAL_STATUS}
                onChange={(e) => setTempo(e)}
                duration
              />
            </Collapse>
            <Collapse opened={valueRadio === 'durationByPeriod'}>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <MuiPickersUtilsProvider
                  locale={ptBrLocale}
                  utils={DateFnsUtils}
                >
                  <DatePicker
                    value={addSomeDaysToDate(date, 1)}
                    placeholder={
                      translation.AbrirVotacaoPautaModal.pickers.datePlaceholder
                    }
                    label={translation.AbrirVotacaoPautaModal.pickers.dateLabel}
                    onChange={(e) => {
                      setDate(format(e || new Date(), 'yyyy-MM-dd'));
                    }}
                    minDate={new Date()}
                    maxDate={dateFormated.setDate(dateFormated.getDate())}
                    format='dd/MM/yyyy'
                    autoOk={true}
                    cancelLabel={
                      translation.AbrirVotacaoPautaModal.pickers
                        .dateCancelButton
                    }
                    minDateMessage={
                      translation.AbrirVotacaoPautaModal.pickers.minDateText
                    }
                    maxDateMessage={
                      translation.AbrirVotacaoPautaModal.pickers.maxDateText
                    }
                  />
                </MuiPickersUtilsProvider>
                <MuiPickersUtilsProvider
                  locale={ptBrLocale}
                  utils={DateFnsUtils}
                >
                  <div className={classes.timeContainer}>
                    <TimePicker
                      label={
                        translation.AbrirVotacaoPautaModal.pickers.timeLabel
                      }
                      placeholder={getHoursAndDate(new Date())}
                      ampm={false}
                      value={
                        createDateFromTextValue(
                          time === null ||
                            time === undefined ||
                            time === 'Invalid date'
                            ? getHoursAndDate(new Date())
                            : time
                        ) as any
                      }
                      onChange={(date: any) => {
                        setTime(getHoursAndDate(date || new Date()));
                      }}
                      cancelLabel={
                        translation.AbrirVotacaoPautaModal.pickers
                          .timeCancelButton
                      }
                      error={
                        (date === format(dateFormatedPublished, 'yyyy-MM-dd') &&
                          time < fullHourPublished) ||
                        (date === format(dateFormated, 'yyyy-MM-dd') &&
                          time > fullHour) ||
                        (date === format(new Date(), 'yyyy-MM-dd') &&
                          time < atualTime)
                      }
                    />
                    {date === format(dateFormatedPublished, 'yyyy-MM-dd') &&
                    time < fullHourPublished ? (
                      <span>
                        {translation.AbrirVotacaoPautaModal.pickers.minTimeText}
                      </span>
                    ) : date === format(dateFormated, 'yyyy-MM-dd') &&
                      time > fullHour ? (
                      <span>
                        {translation.AbrirVotacaoPautaModal.pickers.maxTimeText}
                      </span>
                    ) : date === format(new Date(), 'yyyy-MM-dd') &&
                      time < atualTime ? (
                      <span>
                        {translation.AbrirVotacaoPautaModal.pickers.timeAtual}
                      </span>
                    ) : undefined}
                  </div>
                </MuiPickersUtilsProvider>
              </div>
            </Collapse>
          </Grid>
          <Grid item xs={12} className={classes.actionsContent}>
            <Button
              variant='contained'
              color='primary'
              onClick={confirmar}
              disabled={confirmarDisabled()}
              endIcon={
                salvando ? <SyncIcon className='animation-rotate' /> : null
              }
            >
              {translation.AbrirVotacaoPautaModal.confirmarButton}
            </Button>
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: !salvando ? toClose : undefined,
      }}
    />
  );
}
